import React from "react";
// import "./Banner.css"; // Ensure you import the CSS file
import bannerImg from "../images/homebanner.jpeg"; // Replace with your image path

const Banner = () => {
  return (
    <div className="banner" style={{ backgroundImage: `url(${bannerImg})` }}>
      <div className="banner-overlay">
        <div className="banner-content">
          <h1 className="banner-background">From Our Oven to Your Heart</h1>
          <p className="banner-background">Every celebration deserves something special — we bake not just cakes, but memories that last forever.</p>
         <button
  className="banner-btn"
  onClick={() => window.open("https://sevendaystadigadapa.github.io/", "_blank")}
>
  Explore Our Menu
</button>

        </div>
      </div>
    </div>
  );
};

export default Banner;
